import { useGlobalAPIQueryContext } from "@dev2_techwalnut/tw-api-query-hook";
import { useAPIQuery } from "../../../hooks/useAPIQuery";
import moment from "moment/moment";
import React, { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Error from "../../ErrorPages/Error";
import { useReactToPrint } from "react-to-print";
import Swal from "sweetalert2";
import secureLocalStorage from "react-secure-storage";
import QCAcceptModal from "./modal/QCAcceptModal";
import QCRejectModal from "./modal/QCRejectModal";

const QCReports = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({
        contentRef,
    });

    const userID = secureLocalStorage.getItem("userID");
    const { invalidateApi } = useGlobalAPIQueryContext();
    const { useFetch: useFetchQCGrid } = useAPIQuery({
        key: "qc-report",
        endpoint: "/api/qc/reports/",
    });

    console.log(location.state?.data?.data?.batch?.id);

    const {
        data: qcReportData,
        isLoading: loadingQCReport,
        isError: errorLoadingReport,
        refetch: refetchReportData,
        isFetching: fetchingReportData,
        error,
    } = useFetchQCGrid({
        params: {
            qc_batch_id: location.state?.data?.data?.batch?.id,
        },
        staleTime: 0,
    });

    const { useUpdate: updateQCBatch } = useAPIQuery({
        key: "qc-batch-dropdown",
        endpoint: "/api/check-batch/",
    });

    const { mutate: updateQcBatchData, isPending: updatingQCBatch } =
        updateQCBatch({
            successMessageFromServer: true,
            errorMessageFromServer: true,
            onSuccess: () => {
                refetchReportData();
                invalidateApi({ key: "api/check-batch" });
            },
            onError: () => {
                refetchReportData();
                invalidateApi({ key: "api/check-batch" });
            },
        });

    const handleAcceptQCBatch = () => {
        updateQcBatchData({
            id: location.state?.data?.data?.batch?.id,
            data: {
                qc_result: 1,
                updated_by: userID,
            },
        });
    };

    const handleRejectQCBatch = () => {
        updateQcBatchData({
            id: location.state?.data?.data?.batch?.id,
            data: {
                qc_result: 0,
                updated_by: userID,
            },
        });
    };

    if (loadingQCReport || fetchingReportData) return "Loading...";

    if (errorLoadingReport) {
        Swal.fire({
            title: "Error!",
            text: error?.response?.data?.message,
            icon: "error",
        });
    }

    if (!location.state.data || errorLoadingReport) return <Error />;

    // if (qcReportData?.system_result === 2) {
    //     console.log(error);
    //     Swal.fire({
    //         title: "Error!",
    //         text: "Quality batch is yet to be check.",
    //         icon: "error",
    //     });
    // }

    return (
        <div className="position-relative">
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title">QC Report</h4>
                    </div>
                    <button
                        className="btn btn-sm btn-primary"
                        onClick={() => reactToPrintFn()}
                    >
                        Print
                    </button>
                </div>
            </div>
            <div ref={contentRef}>
                <div className="card">
                    <div className="card-inner">
                        <div className="card-body table-responsive p-0 pb-0">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th colSpan={8} className="text-center">
                                            INCOMING QUALITY TEST CERTIFICATE
                                            ITEM -{qcReportData?.item?.name}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan={2} className="text-center">
                                            <strong>Supplier Name:</strong>
                                        </td>
                                        <td colSpan={3} className="text-center">
                                            {qcReportData?.supplier_details
                                                ?.supplier_name ?? "In House"}
                                        </td>
                                        <td colSpan={3} className="text-center">
                                            <strong>Date of QC</strong>
                                        </td>
                                        {/* <td colSpan={2} className="text-center">
                                            <strong>
                                                Inward/Production Date
                                            </strong>
                                        </td> */}
                                    </tr>
                                    <tr>
                                        <td colSpan={2} className="text-center">
                                            <strong>SKU Description</strong>
                                        </td>
                                        <td colSpan={3} className="text-center">
                                            {qcReportData?.item?.name}
                                        </td>
                                        <td colSpan={3} className="text-center">
                                            {moment(qcReportData?.date).format(
                                                "DD/MM/YYYY"
                                            )}
                                        </td>
                                        {/* <td colSpan={2} className="text-center">
                                            {qcReportData?.inward_date
                                                ? moment(
                                                      qcReportData?.inward_date
                                                  ).format("DD/MM/YYYY")
                                                : "-"}
                                        </td> */}
                                    </tr>
                                    <tr>
                                        <td colSpan={2} className="text-center">
                                            <strong>Invoice No</strong>
                                        </td>
                                        <td colSpan={2} className="text-center">
                                            {qcReportData?.invoice_number ??
                                                "-"}
                                        </td>
                                        <td colSpan={3} className="text-center">
                                            {qcReportData?.batch_number ?? "-"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            colspan="2"
                                            rowSpan={2}
                                            class="text-center"
                                        >
                                            <strong>Invoice Qty</strong>
                                        </td>
                                        <td colspan="6" class="text-center">
                                            Total Quantity ({qcReportData?.uom})
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="6" class="text-center">
                                            {qcReportData?.received_quantity}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="8" class="text-center">
                                            <strong>Sampling Plan</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="text-center">
                                            Sampling Quantity
                                        </td>
                                        <td colspan="2" class="text-center">
                                            {qcReportData?.sample_quantity}
                                        </td>
                                        <td
                                            colspan="2"
                                            class="text-center"
                                        ></td>
                                        <td colspan="2" class="text-center">
                                            -
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="text-center">
                                            <strong>Defects:</strong>
                                        </td>
                                        <td colspan="3" class="text-center">
                                            Acceptance Level
                                        </td>
                                        <td colspan="3" class="text-center">
                                            Actual Observation
                                        </td>
                                    </tr>
                                    {qcReportData?.sample_results?.map(
                                        (res) => (
                                            <tr>
                                                <td
                                                    colspan="2"
                                                    class="text-center"
                                                >
                                                    {res?.severity}
                                                </td>
                                                <td
                                                    colspan="3"
                                                    class="text-center"
                                                >
                                                    {res?.allowed}
                                                </td>
                                                <td
                                                    colspan="3"
                                                    class="text-center"
                                                >
                                                    {res?.observed}
                                                </td>
                                            </tr>
                                        )
                                    )}
                                    <tr>
                                        <td colspan="1" class="text-center">
                                            <strong>Sr. No. </strong>
                                        </td>
                                        <td colspan="2" class="text-center">
                                            <strong>
                                                Defect Classification
                                            </strong>
                                        </td>
                                        <td colspan="2" class="text-center">
                                            <strong>Parameter</strong>
                                        </td>
                                        <td colspan="1" class="text-center">
                                            <strong>Supplier COA</strong>
                                        </td>
                                        <td colspan="2" class="text-center">
                                            <strong>Actual Results</strong>
                                        </td>
                                    </tr>
                                    {qcReportData?.parameter_details?.map(
                                        (details) => (
                                            <>
                                                {details?.parameters?.map(
                                                    (para, i) => (
                                                        <tr>
                                                            <td
                                                                colspan="1"
                                                                class="text-center"
                                                            >
                                                                {i + 1}
                                                            </td>
                                                            {i === 0 ? (
                                                                <td
                                                                    colspan="2"
                                                                    rowSpan={
                                                                        details
                                                                            ?.parameters
                                                                            ?.length
                                                                    }
                                                                    class="text-center"
                                                                >
                                                                    <strong>
                                                                        {
                                                                            details?.severity
                                                                        }
                                                                    </strong>
                                                                </td>
                                                            ) : null}
                                                            <td
                                                                colspan="2"
                                                                class="text-center"
                                                            >
                                                                {
                                                                    para?.parameter__parameter_name
                                                                }
                                                            </td>
                                                            <td
                                                                colspan="1"
                                                                class="text-center"
                                                            ></td>
                                                            <td
                                                                colspan="2"
                                                                class="text-center"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    className={`btn btn-sm btn-${
                                                                        para?.parameter_result ===
                                                                        "Rejected"
                                                                            ? "danger"
                                                                            : "success"
                                                                    }`}
                                                                    onClick={() =>
                                                                        navigate(
                                                                            "/qc-report-details",
                                                                            {
                                                                                state: {
                                                                                    data: {
                                                                                        batch: qcReportData?.qc_batch_id,
                                                                                        parameters:
                                                                                            [
                                                                                                {
                                                                                                    value: para?.parameter_id,
                                                                                                    label: para?.parameter__parameter_name,
                                                                                                },
                                                                                            ],
                                                                                    },
                                                                                },
                                                                            }
                                                                        )
                                                                    }
                                                                >
                                                                    {
                                                                        para?.parameter_result
                                                                    }
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </>
                                        )
                                    )}
                                    <tr>
                                        <td
                                            colspan="2"
                                            rowSpan={2}
                                            class="text-center"
                                        >
                                            <strong>Result</strong>
                                        </td>
                                        <td colspan="2" class="text-center">
                                            Accepted
                                        </td>
                                        <td colspan="2" class="text-center">
                                            Rejected
                                        </td>
                                        <td colspan="2" class="text-center">
                                            Signature
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            colspan="2"
                                            class="text-center text-success"
                                        >
                                            {qcReportData?.qc_result === 1
                                                ? "Accepted by QC head"
                                                : "-"}
                                        </td>
                                        <td
                                            colspan="2"
                                            class="text-center text-danger"
                                        >
                                            {qcReportData?.qc_result === 0
                                                ? "Rejected by QC head"
                                                : "-"}
                                        </td>
                                        <td
                                            colspan="2"
                                            class="text-center"
                                        ></td>
                                    </tr>
                                </tbody>
                            </table>
                            {qcReportData?.qc_result === 2 ? (
                                <div className="m-3">
                                    {/* <button
                                    type="button"
                                    className="btn btn-danger mx-2"
                                    onClick={handleRejectQCBatch}
                                    disabled={updatingQCBatch}
                                >
                                    Reject
                                </button> */}
                                    <QCRejectModal
                                        qcReportData={qcReportData}
                                        qcBatchId={
                                            location.state?.data?.data?.batch
                                                ?.id
                                        }
                                    />
                                    {/* <button
                                    type="button"
                                    className="btn btn-primary mx-2"
                                    onClick={handleAcceptQCBatch}
                                    disabled={updatingQCBatch}
                                >
                                    Accept
                                </button> */}
                                    <QCAcceptModal
                                        qcReportData={qcReportData}
                                        qcBatchId={
                                            location.state?.data?.data?.batch
                                                ?.id
                                        }
                                    />
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
            {updatingQCBatch ? (
                <div
                    className="position-absolute top-0 left-0 h-100 w-100 z-1 d-flex align-items-center justify-content-center"
                    style={{
                        backgroundColor: "rgb(255, 255, 255, 0.5)",
                    }}
                >
                    <div
                        className="spinner-border text-primary ms-2"
                        role="status"
                    >
                        <span className="sr-only"></span>
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default QCReports;
